import { useMemo, useState } from "react";
import { AnyTrackLocation } from "../../../api/anyTrackApi";

interface UseTrailerFilterProps {
  trailers: AnyTrackLocation[];
}

interface UseTrailerFilterResult {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  filteredTrailers: AnyTrackLocation[];
}

export const useTrailerFilter = ({
  trailers,
}: UseTrailerFilterProps): UseTrailerFilterResult => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredTrailers = useMemo(() => {
    let result = trailers;

    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      result = result.filter(
        (trailer) =>
          trailer.vehicleName?.toLowerCase().includes(query) ||
          trailer.licensePlateNumber?.toLowerCase().includes(query) ||
          trailer.deviceId.toLowerCase().includes(query)
      );
    }

    return [...result].sort((a, b) => {
      const aUnplugged = a.deviceStatus === "Unplugged" ? 0 : 1;
      const bUnplugged = b.deviceStatus === "Unplugged" ? 0 : 1;
      return aUnplugged - bUnplugged;
    });
  }, [trailers, searchQuery]);

  return {
    searchQuery,
    setSearchQuery,
    filteredTrailers,
  };
};
